<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt15 pb10">
            <dignose-search-form></dignose-search-form>
            <dignose-apply-form></dignose-apply-form>
            <dignose-tabs></dignose-tabs>
            <div class="mt15">
                <el-table border size="mini" :data="contentData1" :header-cell-style="{backgroundColor:'#fafafa'}">
                    <el-table-column label="申请日期" prop="initDate"></el-table-column>
                    <el-table-column label="患者姓名" prop="consulterName"></el-table-column>
                    <el-table-column label="申请医院" prop="initHosName"></el-table-column>
                    <el-table-column label="影像类型" prop="imageDiagnoseType"></el-table-column>
                    <el-table-column label="患者年龄" prop="age"></el-table-column>
                    <el-table-column label="申请医生" prop="acceptDocName"></el-table-column>
                    <el-table-column label="医生电话" prop="docPhoneNum"></el-table-column>
                    <el-table-column label="会诊医院" prop="acceptHosName"></el-table-column>
                    <el-table-column label="会诊科室" prop="acceptDeptName"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                        <span >{{ scope.row.status=='1'?'已提交':'诊断完成' }}</span>
                    </template></el-table-column>
                    <el-table-column label="操作" fixed="right" width="200px">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handler('detail')">查看</el-button>
                            <el-button size="mini" type="primary" @click="handler('report')">正在出报告</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pt15">
                <el-pagination
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="34">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import DignoseSearchForm from "../components/dignose/search-form";
  import Breadcrumb from "../components/common/Breadcrumb";
  import DignoseApplyForm from "../components/dignose/apply-form";
  import DignoseTabs from "../components/dignose/tabs";
  import {diagnoseMixin} from "../lib/mixins/diagnose";

  export default {
    name: "Dignose",
    data() {
      return {
        list: [1, 1, 1, 1, 1],
        contentData1: [
          {
            initDate:"2018/11/11",
            consulterName:"钟南山",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"x-ray",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDeptName: "内分泌科",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"2",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
          {
            initDate:"2018/11/11",
            consulterName:"谢春花",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"MR",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDeptName: "内分泌科",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"1",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
          {
            initDate:"2018/11/11",
            consulterName:"花粥",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"MR",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDeptName: "内分泌科",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"1",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
        ],
        contentData2: [
          {
            initDate:"2018/11/11",
            consulterName:"钟南山",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"x-ray",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"3",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
          {
            initDate:"2018/11/11",
            consulterName:"谢春花",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"MR",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"2",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
          {
            initDate:"2018/11/11",
            consulterName:"花粥",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"MR",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"2",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
          {
            initDate:"2018/11/11",
            consulterName:"花粥",
            initHosName:"宁海县妇幼保健院",
            imageDiagnoseType:"MR",
            age:"28",
            acceptHosName:"浙医二院",
            acceptDocName:"李悠然",
            docPhoneNum:"15623235656",
            status:"3",//状态，1:已提交,2:诊断完成,3:待诊断,4:已取消,5:已拒绝,
          },
        ],
        form: {},
      }
    },
    computed: {},
    components: {DignoseTabs, DignoseApplyForm, DignoseSearchForm, Breadcrumb},
    mixins: [diagnoseMixin],
    created() {

    },
    mounted() {
    },
    methods: {
      handler(type) {
        const {params} = this.$route;
        this.$router.push(`/main/diagnose/${params.type}/${type}`);
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
